import React from 'react';
import { Alert, Button, Card, Descriptions, Empty, Spin, Tag } from 'antd';
import moment from 'moment';

import AntIcon from '../../shared/components/AntIcon';
import WinnerInfosDisplay from './WinnerInfosDisplay';
import { getGiveawayStatusColor } from '../status';
import {
  formatWinnerProgress,
  isSelectionComplete,
} from '../winners';

function renderBool(value) {
  return value ? 'Yes' : 'No';
}

const PublicPreviewCard = ({ data, error, loading, onRefresh, refreshLoading }) => {
  const campaign = data && data.campaign;
  const complete = data
    ? (data.selectionComplete === true || isSelectionComplete(campaign) || Boolean(data.winnerSelected))
    : false;

  return (
    <Card
      title="Public Giveaway Preview"
      extra={(
        <Button size="small" onClick={onRefresh} loading={refreshLoading}>
          <AntIcon type="reload" />Refresh
        </Button>
      )}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      ) : error ? (
        <Alert type="error" message={error} showIcon />
      ) : !campaign ? (
        <Empty description="No public giveaway campaign is visible right now." />
      ) : (
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="Title">{campaign.title || '-'}</Descriptions.Item>
          <Descriptions.Item label="Slug Month">{campaign.slugMonth || '-'}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={getGiveawayStatusColor(campaign.status)}>{campaign.status}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Selection Date (UTC)">
            {campaign.selectionDateUtc ? moment.utc(campaign.selectionDateUtc).format('YYYY-MM-DD HH:mm [UTC]') : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Banner">
            {campaign.bannerImage ? (
              <a href={campaign.bannerImage} target="_blank" rel="noopener noreferrer">
                Open banner image
              </a>
            ) : (
              'Not set'
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Shoes Image">
            {campaign.shoesImage ? (
              <div>
                <a href={campaign.shoesImage} target="_blank" rel="noopener noreferrer">
                  Open shoes image
                </a>
                <div style={{ marginTop: 8 }}>
                  <img
                    src={campaign.shoesImage}
                    alt="Shoes"
                    style={{ maxWidth: '100%', maxHeight: 120, objectFit: 'contain', borderRadius: 4 }}
                    referrerPolicy="no-referrer"
                  />
                </div>
              </div>
            ) : (
              'Not set'
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Selection Complete">
            {renderBool(complete)}
          </Descriptions.Item>
          <Descriptions.Item label="Winner Progress">
            <Tag color={complete ? 'blue' : 'orange'}>
              {formatWinnerProgress(campaign)}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Winners">
            <WinnerInfosDisplay campaign={data} showProgress={false} size={24} />
          </Descriptions.Item>
          <Descriptions.Item label="CTA Enabled">{renderBool(Boolean(data.ctaEnabled))}</Descriptions.Item>
          <Descriptions.Item label="Today Entry Claimed">
            {renderBool(Boolean(data.todayEntryClaimed))}
          </Descriptions.Item>
          <Descriptions.Item label="Has Prize Profile">
            {renderBool(Boolean(data.hasPrizeProfile))}
          </Descriptions.Item>
          <Descriptions.Item label="User Total Entries">
            {data.userTotalEntries == null ? '-' : data.userTotalEntries}
          </Descriptions.Item>
          <Descriptions.Item label="Next Entry At (UTC)">
            {data.nextEntryAtUtc ? moment.utc(data.nextEntryAtUtc).format('YYYY-MM-DD HH:mm [UTC]') : '-'}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Card>
  );
};

export default PublicPreviewCard;
